// Halaman demo mini game kerja untuk direkam ke reels (tanpa login/energi): /demo-kerja?profesi=penebang&seed=7
import { useSearchParams } from "react-router-dom";
import { Penebang } from "../components/kerja/games/Penebang";

export default function DemoKerja() {
  const [sp] = useSearchParams();
  const shift = { level: Number(sp.get("level") || 1), seed: Number(sp.get("seed") || 7), profesi: sp.get("profesi") || "penebang" };
  return (
    <div data-testid="demo-kerja" style={{ width: "100vw", height: "100vh", overflow: "hidden", background: "#0f1a12" }}>
      <Penebang shift={shift} onSelesai={() => {}} />
    </div>
  );
}
